"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectFaServiceImpl = void 0;
const STORAGE_KEY = 'cms--inspect-fa-service';
class InspectFaServiceImpl {
    getFeatureServiceLoggerRef(name) {
        var _a;
        const loggerRef = (_a = this.options) === null || _a === void 0 ? void 0 : _a.getLoggerRef;
        if (!loggerRef) {
            return undefined;
        }
        return loggerRef(name, name);
    }
    constructor(logger) {
        this.logger = logger;
        this.integratorInspectors = () => [];
        this.monitoringMap = new Map();
        this.listeners = [];
        this.faInstances = [];
        this.load();
    }
    setLogLevel(name, consumerId, logLevel) {
        var _a;
        if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.getLoggerRef) &&
            this.options.getLoggerRef(name, consumerId)) {
            this.options.getLoggerRef(name, consumerId).logLevel = logLevel;
            const fa = this.getFaInstanceById(consumerId);
            if (fa) {
                fa.logLevel = logLevel;
            }
            this.notifyChanges();
        }
    }
    get integrator() {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            featureServiceRegistryInfo: (_a = this.options) === null || _a === void 0 ? void 0 : _a.featureServiceRegistryInfo,
            dependencies: (_b = this.options) === null || _b === void 0 ? void 0 : _b.dependencies,
            testScenarios: (_c = this.options) === null || _c === void 0 ? void 0 : _c.testScenarios,
            featureServiceBundleJsonUrl: (_d = this.options) === null || _d === void 0 ? void 0 : _d.featureServiceBundleJsonUrl,
            basePath: (_e = this.options) === null || _e === void 0 ? void 0 : _e.basePath,
            integratorLoggers: (_f = this.options) === null || _f === void 0 ? void 0 : _f.integratorLoggers,
            views: (_g = this.options) === null || _g === void 0 ? void 0 : _g.views,
        };
    }
    get monitoring() {
        return Array.from(this.monitoringMap.values()).flat(1);
    }
    get enabledMocks() {
        var _a;
        return Boolean((_a = this.options) === null || _a === void 0 ? void 0 : _a.mocksServerConfig);
    }
    get mocksServerConfig() {
        var _a;
        return (_a = this.options) === null || _a === void 0 ? void 0 : _a.mocksServerConfig;
    }
    get enabledLogger() {
        var _a;
        return Boolean((_a = this.options) === null || _a === void 0 ? void 0 : _a.getLoggerRef);
    }
    initialize(options) {
        this.options = options;
    }
    subscribe(cb) {
        this.listeners.push(cb);
        return () => {
            this.listeners.splice(this.listeners.length - 1, 1);
        };
    }
    setMocks(mockIds, environment) {
        var _a, _b, _c;
        if (!this.enabledMocks) {
            return;
        }
        if (!mockIds) {
            mockIds = [];
        }
        const thisMockIds = (_a = this.mockSettings) === null || _a === void 0 ? void 0 : _a.mockIds;
        const equal = thisMockIds &&
            ((_c = (_b = this.mockSettings) === null || _b === void 0 ? void 0 : _b.environment) === null || _c === void 0 ? void 0 : _c.mockEndpoint) === (environment === null || environment === void 0 ? void 0 : environment.token) &&
            mockIds.length === thisMockIds.length &&
            // eslint-disable-next-line security/detect-object-injection
            mockIds.every((m1, index) => m1 === thisMockIds[index] || '');
        if (equal) {
            return;
        }
        if (!environment && !mockIds) {
            this.mockSettings = undefined;
            this.notifyChanges();
            return;
        }
        const newEnvironment = environment
            ? {
                countryCode: environment.countryCode,
                language: environment.language,
                mockEndpoint: environment.token,
                cacheBustingAllowed: false,
            }
            : undefined;
        this.mockSettings = {
            environment: newEnvironment,
            mockIds: mockIds,
        };
        this.persist();
        this.notifyChanges();
    }
    getFaInstances() {
        return this.faInstances;
    }
    addCacheMonitoring(consumerId, name, request) {
        const monitors = this.monitoringMap.get(consumerId) || [];
        monitors.push(Object.assign(Object.assign({}, request), { app: name || consumerId }));
        this.monitoringMap.set(consumerId, monitors);
    }
    removeCacheMonitoring(consumerId) {
        this.monitoringMap.delete(consumerId);
    }
    getFaInstancesByName(name) {
        return this.faInstances.filter((fa) => fa.name === name);
    }
    getFaInstanceById(consumerId) {
        return this.faInstances.find((fa) => fa.consumerId === consumerId);
    }
    registerInstanceByFa(consumerId, name, inspector, version) {
        var _a;
        try {
            const exists = this.faInstances.some((fa) => fa.name == name && fa.consumerId === consumerId);
            if (exists) {
                return false;
            }
            const logLevel = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.getLoggerRef) &&
                this.options.getLoggerRef(name, consumerId)
                ? this.options.getLoggerRef(name, consumerId).logLevel
                : undefined;
            this.faInstances.push({ consumerId, name, inspector, logLevel, version });
            this.notifyChanges();
            return true;
        }
        catch (e) {
            this.logger.error(`failed to register fa ${name}:${consumerId} in inspect fa service`);
            return false;
        }
    }
    unregisterInstance(consumerId) {
        const found = this.faInstances.find((fa) => fa.consumerId === consumerId);
        if (found) {
            this.faInstances.splice(this.faInstances.indexOf(found), 1);
            this.notifyChanges();
            return true;
        }
        return false;
    }
    notifyChanges() {
        this.listeners.forEach((l) => l());
    }
    persist() {
        const data = {
            settings: this.mockSettings,
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
    load() {
        const dataAsString = sessionStorage.getItem(STORAGE_KEY);
        if (dataAsString) {
            try {
                const data = JSON.parse(dataAsString);
                this.mockSettings = data.settings;
            }
            catch (e) {
                this.logger.error('unparsable inspect fa data');
            }
        }
    }
}
exports.InspectFaServiceImpl = InspectFaServiceImpl;
//# sourceMappingURL=v1.js.map